import React from 'react';
import * as actions from '../redux/actions';
import { Link } from 'react-router';
import JsonView from './JsonView';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import Util from '../Util';
import _ from 'lodash';
import Storage from '../Storage';
import AlertNotificationsConfig from './AlertNotificationsConfig';

const groupBy = function (list = [], keys = []) {
  const map = {};
  list.forEach((item) => {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
    const key = keys.reduce((sum, k) => sum + item[k], ''); // add up all the elements in keys array
    const collection = map[key];
    if (!collection) {
      map[key] = [item];
    } else {
      collection.push(item);
    }
  });
  return map;
};

class AppStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: Storage.getSessionItem('AppStatus.toggle') || { difapi: true },
      refreshInProgress: {},
      isRefreshAllInProgress: false,
      selected: null,
    };
    this.handleCheckURLClick = this.handleCheckURLClick.bind(this);
    this.handleCloseInfoModal = this.handleCloseInfoModal.bind(this);
    this.handleDisableAppInfo = this.handleDisableAppInfo.bind(this);
    this.handleEnableAppInfo = this.handleEnableAppInfo.bind(this);
  }

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(actions.getAppInfoList());
    dispatch(actions.getLogURLList());
    this.intervalTimeout = setInterval(() => {
      dispatch(actions.getAppInfoList());
      dispatch(actions.getLogURLList());
    }, 30000);
  }

  componentWillUnmount() {
    this.unmounted = true;
    clearInterval(this.intervalTimeout);
  }

  handleToggle(name) {
    let toggle = { ...this.state.toggle };
    toggle[name] = !toggle[name]; // flip
    this.setState({ toggle });
    Storage.setSessionItem('AppStatus.toggle', toggle);
  }

  handleToggleAll(shouldExpand) {
    let { appInfoList } = this.props;
    let nameMap = groupBy(appInfoList, ['name']);
    let toggle = {};
    for (const name in nameMap) {
      toggle[name] = shouldExpand;
    }
    this.setState({ toggle });
    Storage.setSessionItem('AppStatus.toggle', toggle);
  }

  handleRefreshAll() {
    if (this.state.isRefreshAllInProgress) {
      alert('Check All in progress!');
      return;
    }

    this.setState({ isRefreshAllInProgress: true }, () => {
      this.props
        .dispatch(actions.checkAllAppInfoList())
        .then(() => {
          this.setState({ isRefreshAllInProgress: false });
        })
        .catch((e) => {
          this.setState({ isRefreshAllInProgress: false });
          alert(e.message);
        });
    });
  }

  handleRefreshAppInfo(appInfo) {
    let refreshInProgress = { ...this.state.refreshInProgress };
    if (refreshInProgress[appInfo.checkURL]) {
      alert('Refresh in progress!');
      return;
    }
    refreshInProgress[appInfo.checkURL] = true;
    this.setState({ refreshInProgress }, () => {
      this._refreshAppInfo(appInfo);
    });
  }

  _refreshAppInfo(appInfo) {
    this.props
      .dispatch(actions.checkAndUpdateResult(appInfo))
      .then(() => {
        let refreshInProgress = { ...this.state.refreshInProgress };
        refreshInProgress[appInfo.checkURL] = false;
        this.setState({ refreshInProgress });
      })
      .catch((e) => {
        let refreshInProgress = { ...this.state.refreshInProgress };
        refreshInProgress[appInfo.checkURL] = false;
        this.setState({ refreshInProgress });
        alert(e.message);
      });
  }

  handleCheckURLClick(appInfo) {
    this.setState({ selected: appInfo });
  }

  handleCloseInfoModal() {
    this.setState({ selected: null });
  }

  handleEnableAppInfo(appInfo) {
    appInfo.isDisabled = false;
    this.updateSelectedAppInfo(appInfo);
  }

  handleDisableAppInfo(appInfo) {
    appInfo.isDisabled = true;
    this.updateSelectedAppInfo(appInfo);
  }

  updateSelectedAppInfo(appInfo) {
    let { dispatch } = this.props;
    dispatch(actions.updateAppInfo(appInfo)).then((newAppInfo) => {
      this.setState({ selected: newAppInfo });
    });
  }

  render() {
    let { selected } = this.state;
    let { appInfoList, logURLList, isFullScreen, isSuperUser, userEmail } = this.props;
    let firstAppInfo = appInfoList[0] || {};
    let xAgo = firstAppInfo.checkXAgo || ''; // todo: maybe look at all appInfoList and use the oldest value
    let isAllOperational = isAllAppOperational(appInfoList);

    let nameMapForLogURL = groupBy(logURLList, ['appName']);
    let nameMapForAppInfo = groupBy(appInfoList, ['name']);
    let { toggle, refreshInProgress, isRefreshAllInProgress } = this.state;

    return (
      <div style={{ maxWidth: 1260, margin: '0 auto', paddingTop: 10, paddingBottom: 20 }}>
        <div
          style={{
            backgroundColor: 'white',
            margin: '5px 20px 5px 20px',
            opacity: isRefreshAllInProgress ? 0.4 : 1,
          }}
        >
          <div style={{ backgroundColor: '#ddd', padding: '5px 0' }} className='pure-g pure-u-1'>
            <div className='pure-u-20-24'>
              <a
                onClick={this.handleToggleAll.bind(this, true)}
                href='javascript:void(0)'
                style={{ margin: 5 }}
              >
                Expand All
              </a>{' '}
              |
              <a
                onClick={this.handleToggleAll.bind(this, false)}
                href='javascript:void(0)'
                style={{ margin: 5 }}
              >
                Collapse All
              </a>
            </div>
            <div className='pure-u-4-24' style={{ textAlign: 'right' }}>
              {isFullScreen ? (
                <Link to='/app/status'>back</Link>
              ) : (
                <Link to='/status'>full screen</Link>
              )}
            </div>
          </div>
          <div
            style={{
              backgroundColor: isAllOperational ? '#2ecc71' : 'red',
              color: 'white',
              padding: 15,
              fontSize: 24,
            }}
            className='pure-g pure-u-1'
          >
            <div className='pure-u-14-24'>
              {isAllOperational ? 'All Services Operational' : 'Service Down'}
            </div>
            <div
              className='pure-u-10-24'
              style={{ textAlign: 'right', verticalAlign: 'middle', fontSize: 14 }}
            >
              <span>Refreshed less than {xAgo}</span>
            </div>
          </div>
          {Object.keys(nameMapForAppInfo).map((name) => {
            return (
              <AppSection
                key={name}
                name={name}
                appInfoList={nameMapForAppInfo[name]}
                logURLList={nameMapForLogURL[name]}
                expanded={toggle[name]}
                onToggle={this.handleToggle.bind(this, name)}
                onRefresh={this.handleRefreshAppInfo.bind(this)}
                refreshInProgress={refreshInProgress}
                onCheckURLClick={this.handleCheckURLClick}
                isSuperUser={isSuperUser}
                userEmail={userEmail}
              />
            );
          })}
          {/*<JsonView title="nameMap" data={nameMap} shouldExpandNode={() => false} />*/}
          {/*<JsonView title="appInfoList" data={appInfoList} shouldExpandNode={() => false} />*/}
        </div>
        <div style={{ margin: '0px 20px 20px 20px' }}>
          <a
            onClick={this.handleRefreshAll.bind(this)}
            href='javascript:void(0)'
            style={{ margin: 5 }}
          >
            <span
              className={isRefreshAllInProgress ? 'fa fa-refresh fa-spin' : 'fa fa-refresh'}
              style={{ margin: 5 }}
            />
            Manual Check All
          </a>
        </div>

        {this.state.selected && (
          <ModalContainer onClose={this.handleCloseInfoModal}>
            <ModalDialog onClose={this.handleCloseInfoModal}>
              {isSuperUser && (
                <div style={{ marginBottom: '10px' }}>
                  <div style={{ marginBottom: 10 }}>
                    App Status Check:
                    <strong>{selected.isDisabled ? ' Disabled' : ' Enabled'}</strong>
                  </div>
                  <button
                    disabled={!selected.isDisabled}
                    style={{ opacity: !selected.isDisabled ? 0.2 : 1, marginRight: 10 }}
                    onClick={this.handleEnableAppInfo.bind(this, selected)}
                  >
                    Enable
                  </button>
                  <button
                    disabled={selected.isDisabled}
                    style={{ opacity: selected.isDisabled ? 0.2 : 1 }}
                    onClick={this.handleDisableAppInfo.bind(this, selected)}
                  >
                    Disable
                  </button>
                </div>
              )}
              <a href={selected.checkURL} target='_blank'>
                {selected.checkURL} <span className='fa fa-external-link' />
              </a>
              <JsonView data={selected} title={selected.name + ' ' + selected.hostname} />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    );
  }
}

// const emptyFn = () => {};

function AppSection(props) {
  let {
    name, appInfoList, logURLList, expanded, onToggle, onRefresh,
    refreshInProgress, onCheckURLClick, isSuperUser, userEmail
  } = props;

  // console.log(props);

  let isAllOperational = isAllAppOperational(appInfoList);
  let hasDisabled = hasDisabledAppInfo(appInfoList);
  let version = getAppVersion(name, appInfoList);

  let toggleIconClassName = 'fa fa-caret-right';
  if (expanded) {
    toggleIconClassName = 'fa fa-caret-down';
  }

  let difapiInfo = null;
  if (/difapi/i.test(name)) {
    let list = appInfoList.filter((appInfo) => /\/status\/info$/.test(appInfo.checkURL));
    if (list.length > 0) {
      let difapi = list[0];
      difapiInfo = Util.jsonParse(difapi.checkResult, {});
    }
  }

  const isCapAdm = /capadm/i.test(name);

  return (
    <div
      className='pure-g pure-u-1'
      key={name}
      style={{ padding: 20, borderBottom: '1px solid #ccc' }}
    >
      <div className='' style={{ fontSize: 20 }}>
        <div onClick={onToggle} style={{ cursor: 'pointer' }} className='pure-u-14-24'>
          <span
            style={{ color: '#999', fontSize: 12, paddingRight: '5px' }}
            className={toggleIconClassName}
          />
          {name} {version ? <span style={{ fontSize: 12, fontWeight: 500 }}> {version} </span> : ''}
          {hasDisabled ? (
            <span style={{ fontSize: 12, color: 'darksalmon' }}>(contains disabled checkURL)</span>
          ) : ('')}
        </div>
        <div className='pure-u-10-24' style={{ textAlign: 'right' }}>
          {isAllOperational ? (
            <div style={{ color: 'green' }}>Operational</div>
          ) : (
            <div style={{ color: 'red' }}>Service Down</div>
          )}
        </div>
      </div>

      {expanded && isCapAdm && (
        <AlertNotificationsConfig isSuperUser={isSuperUser} userEmail={userEmail} />
      )}
      {expanded && (
        <div style={{ margin: 10 }}>
          {difapiInfo && (
            <div style={{ marginBottom: '30px', fontSize: 14 }}>
              <div className='pure-g pure-u-1' style={{ fontSize: 12, fontWeight: 600 }}>
                <div className='pure-u-10-24'>DIF Service</div>
                <div className='pure-u-8-24'>Last Message Date Time</div>
                <div className='pure-u-6-24' style={{ textAlign: 'right' }}>
                  Status
                </div>
              </div>
              {Object.keys(difapiInfo).map((key) => {
                let value = difapiInfo[key];
                let title = _.startCase(key);
                return (
                  <div
                    className='pure-g pure-u-1'
                    key={key}
                    style={{ borderBottom: '1px solid #eee', padding: '5px 0' }}
                  >
                    <div className='pure-u-10-24'>{title}</div>
                    <div className='pure-u-8-24'>
                      {value.lastMessageDateTime ? value.lastMessageDateTime : ''}
                    </div>
                    <div
                      className='pure-u-6-24'
                      style={{ textAlign: 'right', color: value.isRunning ? 'green' : 'red' }}
                    >
                      {value.isRunning ? 'Running' : 'Not Running'}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {logURLList && logURLList.length > 0 && (
            <div style={{ marginBottom: '30px', fontSize: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>Log URL</div>
              <ul style={{ margin: '5px', padding: 0 }}>
                {logURLList.map((logURL) => {
                  return (
                    <li key={logURL.id} style={{ margin: '5px 20px' }}>
                      <a href={logURL.logURL} target={logURL.id}>
                        {logURL.logName} <span className='fa fa-external-link' />
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className='pure-g pure-u-1' style={{ fontSize: 12, fontWeight: 600 }}>
            <div className='pure-u-10-24'>Check URL</div>
            <div className='pure-u-4-24'>Hostname</div>
            <div className='pure-u-6-24'>Status Code</div>
            <div className='pure-u-4-24' style={{ textAlign: 'right' }}>
              Check Date
            </div>
          </div>

          {appInfoList.map((appInfo) => {
            let isRefreshInProgress = refreshInProgress[appInfo.checkURL];
            let refreshIconClassName = 'fa fa-refresh';
            if (isRefreshInProgress) {
              // console.log(name, isRefreshInProgress);
              refreshIconClassName = 'fa fa-refresh fa-spin';
            }

            return (
              <div
                className='pure-g pure-u-1'
                key={appInfo.hostname + appInfo.checkURL}
                style={{
                  fontSize: '1.2em',
                  margin: '0',
                  borderBottom: '1px solid #eee',
                  opacity: appInfo.isDisabled ? 0.5 : 1,
                  padding: '5px 0',
                }}
              >
                <div className='pure-u-10-24'>
                  <div style={{ marginRight: 10, display: 'none', cursor: 'pointer' }}>
                    <span className='fa fa-edit' />
                  </div>
                  <div
                    onClick={onRefresh.bind(this, appInfo)}
                    style={{ marginRight: 10, display: 'inline-block', cursor: 'pointer' }}
                  >
                    <span className={refreshIconClassName} />
                  </div>
                  <a onClick={onCheckURLClick.bind(this, appInfo)} href='javascript:void(0)'>
                    {appInfo.checkURL}
                  </a>{' '}
                  {appInfo.isDisabled ? ' (check disabled)' : ''}
                </div>
                <div className='pure-u-4-24'>{appInfo.hostname}</div>
                <div className='pure-u-6-24'>
                  <span style={{ color: appInfo.isValidCheckStatusCode ? 'green' : 'red' }}>
                    {appInfo.checkStatusCodeDesc}
                  </span>
                  <br />
                  <span style={{ color: appInfo.isValidPrevCheckStatusCode ? 'green' : 'red' }}>
                    {appInfo.prevCheckStatusCodeDesc}
                  </span>
                </div>
                <div className='pure-u-4-24' style={{ textAlign: 'right' }}>
                  <span title={appInfo.checkLocalDateTime}>{appInfo.checkXAgo}</span>
                  <br />
                  <span title={appInfo.prevCheckLocalDateTime}>{appInfo.prevCheckXAgo}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function isAllAppOperational(appInfoList) {
  return appInfoList.every((appInfo) => {
    return !appInfo.isDisabled ? appInfo.isOperational : true;
  });
}

function hasDisabledAppInfo(appInfoList) {
  let allEnabled = appInfoList.every((appInfo) => {
    return !appInfo.isDisabled;
  });
  return !allEnabled;
}

function getAppVersion(name, appInfoList) {
  let matchedList = appInfoList.filter((appInfo) => appInfo.name === name);
  let versions = new Set();
  for (let appInfo of matchedList) {
    try {
      let resultObj = JSON.parse(appInfo.checkResult);
      let version = resultObj.version;
      if (version) {
        versions.add(version);
      }
    } catch (ignored) {
      // console.debug(ignored);
    }
  }
  let verStr = '';
  versions.forEach((v) => {
    verStr += ' ' + v;
  });
  return verStr;
}

export default AppStatus;



// WEBPACK FOOTER //
// ./src/components/AppStatus.js